export default __webpack_public_path__ + "static/media/hunting-exprience-1.594cd1ff.jpg";